const getCharCode = (event) => {
  const chCode = ('charCode' in event) ? event.charCode : event.keyCode;
  return chCode;
};

/* eslint-disable no-param-reassign */
const setSelectOption = (selectElement, value) => {
  const options = [];

  for (let i = 0; i < selectElement.options.length; i++) {
    options.push(selectElement.options[i]);
  }

  return options
    .some((option, index) => {
      if (option.value === value) {
        selectElement.selectedIndex = index;
        return true;
      }
      return false;
    });
};
/* eslint-enable no-param-reassign */

const getCookie = (name) => {
  // Split cookie string and get all individual name=value pairs in an array
  const cookieArr = document.cookie.split(';');
  let i = 0;
  for (i = 0; i < cookieArr.length; i++) {
    const cookiePair = cookieArr[i].split('=');
    if (name === cookiePair[0].trim()) {
      // Decode the cookie value and return
      return decodeURIComponent(cookiePair[1]);
    }
  }
  return null;
};

const isModalRAQ = () => {
  let isModal = false;
  if (document.querySelector('.modal-raq') || document.querySelector('bap-content-modal') || document.querySelector('offers-modal-wrapper')) {
    isModal = true;
  }
  return isModal;
};

const utils = {
  getCharCode,
  setSelectOption,
  getCookie,
  isModalRAQ,
};

module.exports = utils;
